var Ntss;
(function (Ntss) {
    "use strict";
    // KO viewmodel
    var contactVm = {};
    // This gets called when the document loads
    $(() => {
        _addFormatNameFieldsListeners();
        _addFormatPhoneListener();
        _preventEnterDefault();
        _setupValidation();
    });
    function _setupValidation() {
        $("#contact-form").validate({
            submitHandler: (form) => {
                $('input[type="submit"]').data('loading-text', 'Submitting...');
                //$('input[type="submit"]', form).button('loading');
                if ($(form).data('submitted') === true) {
                    return false;
                }
                else {
                    $(form).data('submitted', true);
                    var timeout = setTimeout(() => {
                        //$('input[type="submit"]', form).button('reset');
                        alert('Form failed to submit within 5 minutes');
                        clearTimeout(timeout);
                    }, 300000);
                    return true;
                }
            }
        });
    }
    function _addFormatNameFieldsListeners() {
        $("input[id$='Name']").on("blur", (evt) => {
            const firstName = $("#ContactForm_FirstName").val().toTitleCase().trim();
            $("#ContactForm_FirstName").val(firstName);
            const lastName = $("#ContactForm_LastName").val().toTitleCase().trim();
            $("#ContactForm_LastName").val(lastName);
        });
    }
    function _addFormatPhoneListener() {
        $("#ContactForm_Phone").on("keyup", (evt) => {
            const val = $("#ContactForm_Phone").val();
            if (!val)
                return;
            const formattedVal = Ntss.formatPhone(val).trim();
            $("#ContactForm_Phone").val(formattedVal);
        });
    }
    /**
     * Prevents the enter key press from submitting the form prematurely
     */
    function _preventEnterDefault() {
        $(window).keydown((evt) => {
            if (evt.keyCode === 13) {
                evt.preventDefault();
                return;
            }
        });
    }
})(Ntss || (Ntss = {}));
